import { FormButtons, IFormProps } from "../Interfaces/FormProps";

export const convertButtonsToList = (props: IFormProps<any>) => {
  if (props.buttonList) {
    return props.buttonList;
  }

  const buttons: FormButtons[] = [];

  if (props.buttons?.reset) {
    buttons.push({
      type: "reset",
      label: props.buttons.reset.label,
      id: props.buttons.reset.id ?? "resetButton",
      handle: props.handleReset,
      layout: "secondary"
    });
  }

  if (props.buttons?.submit && props.handleSubmit) {
    buttons.push({
      type: "submit",
      label: props.buttons.submit.label,
      id: props.buttons.submit.id ?? "submitButton",
      handle: props.handleSubmit,
      layout: "primary"
    });
  }

  return buttons;
};
